import { apiClient } from './api'

export interface AIInsight {
  id: number
  entity_type: string
  entity_id: number
  type: string
  title: string
  content: string
  confidence: number | null
  target_role: string | null
  urgency: string | null
  created_at: string
  ai_powered: boolean
  reasoning: string | null
  suggested_actions: string[] | null
  feedback_score: number | null
  feedback_text: string | null
  outcome_verified: boolean | null
  outcome_verified_at?: string | null
  outcome_notes?: string | null
  outcome_prompt_sent_at?: string | null
}

export interface RiskIssueAnalysis {
  type: 'risk' | 'issue'
  title: string
  content: string
  reasoning: string
  probability: 'High' | 'Medium' | 'Low'
  impact: 'High' | 'Medium' | 'Low'
  urgency: 'critical' | 'high' | 'medium' | 'low'
  suggested_actions: string[]
  similar_past_items: string[]
  target_role: string
  confidence: number
}

export interface ListInsightsParams {
  entity_type?: string
  entity_id?: number
  target_role?: string
  limit?: number
}

export const aiInsightsService = {
  async list(params?: ListInsightsParams): Promise<AIInsight[]> {
    const { data } = await apiClient.get<AIInsight[]>('/api/v1/ai/insights', { params })
    return data
  },

  async generate(entity_type: string, entity_id: number, target_role = 'all'): Promise<{ generated: number; insights: AIInsight[] }> {
    const { data } = await apiClient.post('/api/v1/ai/insights/generate', {
      entity_type,
      entity_id,
      target_role,
    })
    return data
  },

  async submitFeedback(insight_id: number, score: -1 | 0 | 1, text?: string): Promise<void> {
    await apiClient.post(`/api/v1/ai/insights/${insight_id}/feedback`, { score, text })
  },

  async analyzeRisk(item_id: number): Promise<RiskIssueAnalysis> {
    const { data } = await apiClient.post<RiskIssueAnalysis>(`/api/v1/ai/insights/analyze/risk/${item_id}`)
    return data
  },

  async analyzeIssue(item_id: number): Promise<RiskIssueAnalysis> {
    const { data } = await apiClient.post<RiskIssueAnalysis>(`/api/v1/ai/insights/analyze/issue/${item_id}`)
    return data
  },
}
